import { tv } from 'tailwind-variants';

import useLocation from 'lib/hooks/useLocation';
import usePlans from 'lib/hooks/usePlans';

import {
  Flag,
  formatCurrency,
  Loader,
} from '@frontendmentorio/design-system-v2';

const styles = tv({
  slots: {
    originalPrice: [
      'font-bold',
      'line-through',
      'opacity-40',
      'text-neutral-500',
    ],
    billingInterval: ['font-normal', 'pt-1', 'text-sm', 'text-neutral-500'],
  },
});

export default function MonthlyPrice() {
  const { location } = useLocation();
  const { monthly } = usePlans();

  if (!location) return <Loader />;

  const { currencyCode: code, locale } = location;
  const { originalPrice, billingInterval } = styles();

  return (
    <div className="flex flex-col gap-1 items-center justify-center mb-auto text-center">
      {monthly.discountedPrice < monthly.price && (
        <del className={originalPrice()}>
          {formatCurrency(monthly.price, { code, locale })}
          /month
        </del>
      )}

      <div className="flex flex-col gap-1 items-center">
        <span className="font-semibold text-2xl">
          {formatCurrency(monthly.discountedPrice, { code, locale })}
          /mo
        </span>

        {monthly.discountString && (
          <Flag className="brightness-150 px-3">
            {monthly.discountString} off
          </Flag>
        )}
      </div>

      <span className={billingInterval()}>Billed monthly</span>
    </div>
  );
}
